import { render, staticRenderFns } from "./SlideButton.vue?vue&type=template&id=5f033827&"
import script from "./SlideButton.vue?vue&type=script&lang=js&"
export * from "./SlideButton.vue?vue&type=script&lang=js&"
import style0 from "./SlideButton.vue?vue&type=style&index=0&id=5f033827&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports